import { render, staticRenderFns } from "./VideoTest.vue?vue&type=template&id=6049ce06&scoped=true"
import script from "./VideoTest.vue?vue&type=script&lang=js"
export * from "./VideoTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6049ce06",
  null
  
)

export default component.exports